import { NgModule } from '@angular/core';
import { AlertComponent } from './alert.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AlertComponent],
  imports: [CommonModule, NgbModule, HttpClientModule],
  exports: [AlertComponent],
})
export class AlertModule {}
